// extracted by mini-css-extract-plugin
export var image = "BannerSection-module--image--b9ab1";
export var wrapper = "BannerSection-module--wrapper--653d9";